module.exports = __webpack_public_path__ + "img/1499375156.dcb99d1d.jpg";